import Modal from "../../../../elements/Modal";
import ManageReply from "../ManageReply";

const ManageReplyModal = ({
  open,
  close = () => {},
  getResponse = {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl4" title={"Send Reply"}>
      <ManageReply close={close} getResponse={getResponse} data={data} />
    </Modal>
  );
};

export default ManageReplyModal;
